import { t, Trans } from "@lingui/macro";
import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@reactive-resume/ui";
import { useRef, useState } from "react";

import { useDialog } from "@/client/stores/dialog";

import { useAccountOverview } from "../../hooks/use-account-overview";

export const useCoverLetterAccess = () => {
  const { refetch } = useAccountOverview();
  const { open: openOffers } = useDialog("forfait");
  const checking = useRef(false);
  const [pending, setPending] = useState(false);
  const [notice, setNotice] = useState<"pack" | "error" | null>(null);

  const requestAccess = async (onAllowed: () => void) => {
    if (checking.current) return;
    checking.current = true;
    setPending(true);

    try {
      const result = await refetch({ throwOnError: true });
      const plan = result.data?.currentPlan;
      const now = Date.now();
      if (result.isError || !result.data) {
        setNotice("error");
      } else if (
        !plan?.validFrom ||
        !plan.validTo ||
        !(plan.validFrom.getTime() <= now && now < plan.validTo.getTime())
      ) {
        setNotice("pack");
      } else {
        setNotice(null);
        onAllowed();
      }
    } catch {
      setNotice("error");
    } finally {
      checking.current = false;
      setPending(false);
    }
  };

  const accessDialog = (
    <Dialog open={notice !== null} onOpenChange={(open) => !open && setNotice(null)}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>
            {notice === "error" ? t`Vérification indisponible` : t`Un pack actif est nécessaire`}
          </DialogTitle>
          <DialogDescription>
            {notice === "error"
              ? t`Impossible de vérifier votre pack. Réessayez dans un instant.`
              : t`La création de lettres de motivation est réservée aux comptes disposant d’un pack actif. L’éditeur de lettres est encore en préparation.`}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button variant="outline" onClick={() => setNotice(null)}>
            <Trans>Fermer</Trans>
          </Button>
          {notice === "pack" && (
            <Button
              onClick={() => {
                setNotice(null);
                openOffers("create", { id: "forfait" });
              }}
            >
              <Trans>Consulter les packs</Trans>
            </Button>
          )}
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );

  return { requestAccess, pending, accessDialog };
};
